import { apolloClient } from '~/apollo';
import { GET_ECG_HISTORY_LIST } from '~/graphql/queries';
import { EcgHistoryScope } from '~/models/common';

export const getEcgHistoryList = async (params: {
  day: number;
  month: number;
  year: number;
  userId: string;
  isLatest?: boolean;
  historyScope?: EcgHistoryScope;
  historyMonth?: number;
  historyYear?: number;
}): Promise<any> => {
  return apolloClient.query({
    query: GET_ECG_HISTORY_LIST,
    variables: {
      day: params.day,
      month: params.month,
      year: params.year,
      userId: params.userId,
      isLatest: params.isLatest ?? false,
      historyScope: params.historyScope ?? EcgHistoryScope.Day,
      historyMonth: params.historyMonth,
      historyYear: params.historyYear,
    },
    fetchPolicy: 'network-only',
  });
};
